
import api, {
  respTypeBlob, 
  apiInternal
 } from '../api';

export async function getAllStatByWeek() {
  const { data } = await api.post(`${apiInternal}/export/AllStatByWeek`,{ }, respTypeBlob);
  return data;     
}
export async function getStatEsta( estaId) {
  const { data } = await api.post(`${apiInternal}/export/StatEstablishment`,{ esta_id: estaId }, respTypeBlob );
  return data;     
}
export async function getAppDeviceVersion() {
  const { data } = await api.post(`${apiInternal}/export/AppDeviceVersion`,{ }, respTypeBlob);
  return data;    
}
export async function getSuiviClient(dStart, dEnd){
  const { data } = await api.post(`${apiInternal}/export/suiviclient`,{start: dStart, end: dEnd }, respTypeBlob);
  return data;    
}

export async function getStatForEstablishmentParticipationActivities(estaId, start, end) {
  const { data } = await api.post(`${apiInternal}/export/StatEstablishmentParticipationActivities`, { esta_id: estaId, datestart: start, dateend: end });
  return data;
}